<template>
  <div class="lcu-page">
    <section class="section">
      <annoucement-banner />
      <page-legend :loading="programLoading" :breadcrumbs="[
        { link: '/programas', text: 'Todos los programas' },
        { link: '/programas/' + program.slug, text: program.degree + ' en ' + program.name },
        { text: 'Regístrate' },
        ]"/>
    </section>
    <div class="row row-center" v-if="programLoading">
      <spin-loader :size="'100px'" />
    </div>
    <div v-else>
      <div v-if="programLoadError" class="row row-center">
        <div class="row">
          <img
            src="/assets/broken-page-primary.svg"
            class="lcu-program-brokenImg"
            alt="Programa no cargado" />
        </div>
        <p class="lcu-programLoad-error">
          {{ programLoadError }}
        </p>
        <button-cta
          :text="TRY_AGAIN"
          :loading="programLoading"
          border
          @on-click="getProgram" />
      </div>
      <div v-else>
        <div
          v-if="user.programs &&
          user.programs[program?.slug] &&
          registrationStep !== 'completed'">
          <section class="section">
            <header class="lcu-section-header lcu-center-text">
              {{ program.degree }} en {{ program.name }} - Programa
            </header>
          </section>
          <section class="section">
            <div class="row row-center">
              <img
                :src="program.image"
                class="lcu-registered-image"
                alt="Program logo" />
            </div>
            <p class="lcu-program-registered">
              Ya estás registrado en este programa.
            </p>
            <div class="row row-center">
              <button-cta
                :text="'Ir al Programa'"
                border
                :class="['lcu-registered-button']"
                @on-click="$router.push({ path: '/programas/registrada/' + program.slug })" />
            </div>
          </section>
        </div>
        <div v-else>
          <section class="section">
            <header class="lcu-section-header lcu-center-text">
              Registrarse - {{ program.degree }} en {{ program.name }} - Programa
            </header>
          </section>
          <section class="section">
            <bullet-legend :amount="3" :current="getCurrentStep" />
          </section>
          <!-- <div v-if="registrationStep === 'learning-preference'">
            <section class="section">
              <header class="lcu-section-subHeader lcu-center-text">
                ¿Cuál es tu preferencia de aprendizaje?
              </header>
            </section>
            <section class="section">
              <div class="col-grid-2 lcu-learn-options">
                <div
                  class="lcu-learn-option"
                  @click.prevent="learnPreference = 'read'"
                  :class="{ 'lcu-selected-option': learnPreference === 'read' }">
                  <img class="lcu-learn-icon" src="./images/book.svg" />
                  <div>
                    Lectura
                  </div>
                </div>
                <div
                  class="lcu-learn-option"
                  @click.prevent="learnPreference = 'listen'"
                  :class="{ 'lcu-selected-option': learnPreference === 'listen' }">
                  <img class="lcu-learn-icon" src="./images/audio.svg" />
                  <div>
                    Escuchar
                  </div>
                </div>
              </div>
              <div class="col-grid-2 lcu-learn-options">
                <div />
                <button-cta
                  :text="'SIGUIENTE PASO'"
                  :loading="false"
                  :classes="['lcu-next-btn']"
                  border
                  @on-click="registrationStep = 'agreement'" />
              </div>
            </section>
          </div> -->
          <div v-if="registrationStep === 'agreement'">
            <section class="section">
              <header class="lcu-section-subHeader lcu-center-text">
                Acuerdo del programa
              </header>
            </section>
            <section class="section">
              <div class="lcu-paper-terms lcu-center-text">
                <p>
                  Al inscribirse en este programa, usted comprende que, para recibir
                  la acreditación completa, debe:
                </p>
                <p>
                  <strong>1. </strong> Completar cada una de las secciones relacionadas con este
                  programa.<br/><br/>
                  <strong>2. </strong> Aprobar cualquier examen necesario relacionado con
                  este programa.<br/><br/>
                  <strong>3. </strong> Abonar la totalidad de las tasas y cargos adeudados
                  en relación con este programa.<br/><br/>
                </p>
                <p>
                  Como estudiante, al inscribirse en un programa, usted adquiere una licencia
                  de Legacy Christian University para visualizar el contenido a través de
                  cualquiera de nuestras plataformas; siendo Legacy Christian University el
                  licenciante oficial. El contenido se otorga bajo licencia y no se le vende
                  a usted. Esta licencia no le confiere ningún derecho a revender el contenido
                  de ninguna manera (lo cual incluye compartir la información de su cuenta con
                  un comprador o descargar el contenido de forma ilegal para compartirlo en
                  cualquier lugar).
                </p>
                <div class="row">
                  <div class="lcu-terms-wrapper">
                    <form-field
                      :id="'agree-terms'"
                      :sideLabel="true"
                      :links="[{
                        text: 'Terminos de Uso',
                        href: '/terminos-de-uso',
                        target: '_blank',
                        rel: 'noopener noreferrer',
                      },
                      {
                        text: ' y ',
                      },
                      {
                        text: 'Acuerdo de Confidencialidad',
                        href: '/acuerdo-de-confidencialidad',
                        target: '_blank',
                        rel: 'noopener noreferrer',
                      }]"
                      :label="'Acepto todos.'">
                      <input
                        type="checkbox"
                        name="agree-terms"
                        id="agree-terms"
                        v-model="programAgreement"
                        class="lcu-form-checkbox" />
                    </form-field>
                  </div>
                </div>
              </div>
              <div class="col-grid-2">
                <button-cta
                  :text="'REGRESAR'"
                  :classes="['lcu-back-btn']"
                  border
                  @on-click="registrationStep = 'learning-preference'" />
                <button-cta
                  :text="'SIGUIENTE PASO'"
                  :disabled="!programAgreement"
                  @on-click="registrationStep = 'confirm'" />
              </div>
            </section>
          </div>
          <div v-if="registrationStep === 'confirm'">
            <section class="section">
              <header class="lcu-section-subHeader lcu-center-text">
                Confirmación y Pago
              </header>
            </section>
            <section class="section">
              <div class="col-grid-2">
                <div>
                  <div class="row">
                    <h3 class="lcu-section-subHeader">Tipo de Pago</h3>
                    <hr class="line-break"/>
                  </div>
                  <div class="row">
                    <div class="lcu-radio-field">
                      <input
                        id="payment-type-full"
                        class="lcu-radio-input"
                        name="Pay in full"
                        value="full"
                         @change="onSelectFull"
                        v-model="paymentType"
                        type="radio" />
                      <label
                        for="payment-type-full"
                        class="lcu-radio-label">Pagar total</label>
                    </div>
                    <div class="lcu-radio-field">
                      <input
                        id="payment-type-installments"
                        class="lcu-radio-input"
                        name="Pay in installments"
                        value="installments"
                        @change="onSelectInstallments"
                        v-model="paymentType"
                        type="radio" />
                      <label
                        for="payment-type-installments"
                        class="lcu-radio-label">Pagar a plazos</label>
                    </div>
                    <div class="row" v-if="paymentType === 'installments'">
                      <div
                        class="lcu-card-container"
                        :class="{
                          'lcu-card-containerError': installmentError
                        }">
                        <div
                          class="row row-center"
                          v-if="installmentLoading && !installmentError">
                          <spin-loader />
                        </div>
                        <div v-if="!installmentLoading && !installmentError">
                          <div class="lcu-installment-header">
                            <span>Cantidad</span>
                            <span>Fecha de Vencimiento</span>
                          </div>
                          <div class="lcu-installment-body">
                            <div
                              class="lcu-installment-row"
                              :class="{
                                'lcu-installment-bold': installment.dueDate === 'Today',
                              }"
                              v-for="installment in installments"
                              :key="installment.dueDate">
                              <span>{{ installment.amount }}</span>
                              <span>
                                {{ installment.dueDate === 'Today' ? 'Hoy' : installment.dueDate }}
                              </span>
                            </div>
                          </div>
                          <span class="lcu-small-disclaimer">
                            Los pagos futuros no se cobran automáticamente, por lo que
                            deberá pagar cada mensualidad de forma manual en la sección
                            de facturación. Los totales mostrados son aproximados.
                          </span>
                          <span class="lcu-small-disclaimer">
                             El material del programa no estará disponible si hay pagos en
                             parcialidades vencidos. Además, este programa no podrá completarse
                             hasta cubrir en su totalidad el saldo pendiente de
                             ({{ getProgramTotals.total }}). Al seleccionar esta opción,
                             usted acepta estos términos.
                          </span>
                        </div>
                        <div
                          class="lcu-retrieve-errorMsg"
                          v-if="installmentError && !installmentLoading">
                          {{ installmentError }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <h3 class="lcu-section-subHeader">Método de Pago</h3>
                    <hr class="line-break"/>
                  </div>
                  <div class="row">
                    <div class="lcu-radio-field">
                      <input
                        id="payment-method-new"
                        class="lcu-radio-input"
                        name="Payment method new"
                        value="new"
                        v-model="paymentMethod"
                        type="radio" />
                      <label
                        for="payment-method-new"
                        class="lcu-radio-label">Nuevo método de pago</label>
                    </div>
                    <div class="row" v-if="paymentMethod === 'new'">
                      <div class="lcu-card-container">
                        <div class="row">
                          <div class="row row-small">
                            <form-field :id="'name'" :label="''" required>
                              <input
                                type="text"
                                id="name"
                                @input="validate(['name'])"
                                placeholder="Nombre en tarjeta"
                                v-model="validations.name.value"
                                :class="{
                                  'lcu-register-inputError': validations.name.errors.length > 0
                                }"
                                class="lcu-register-inputText lcu-stripe-input" />
                            </form-field>
                          </div>
                          <div class="row row-small" v-if="validations.name.errors.length > 0">
                            <span class="lcu-register-errorMsg">
                              {{ validations.name.errors.join(' ') }}
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="stripe-card-section">
                            <div id="card-element" class="stripe-card-input"></div>
                            <div id="card-errors" class="stripe-error-message" role="alert">
                              {{ stripeCardError }}
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <form-field
                            :id="'save-payment'"
                            :sideLabel="true"
                            :label="'Guardar método de pago'">
                            <input
                              type="checkbox"
                              name="save-payment"
                              id="save-payment"
                              v-model="savePaymentMethod"
                              class="lcu-form-checkbox" />
                          </form-field>
                        </div>
                      </div>
                    </div>
                    <div class="lcu-radio-field">
                      <input
                        id="payment-method-existing"
                        class="lcu-radio-input"
                        name="Payment method existing"
                        value="existing"
                        v-model="paymentMethod"
                        @change="loadPaymentMethods"
                        type="radio" />
                      <label
                        for="payment-method-existing"
                        class="lcu-radio-label">Método de pago existente</label>
                    </div>
                    <div class="row" v-if="paymentMethod === 'existing'">
                      <div class="lcu-card-container"
                        :class="{
                          'lcu-card-containerError':
                            existingMethods.length < 2 && existingPaymentError
                        }">
                        <div
                          class="row row-center"
                          v-if="loadingPaymentMethods && !loadPaymentMethodsError">
                          <spin-loader />
                        </div>
                        <div v-if="!loadingPaymentMethods && !loadPaymentMethodsError">
                          <div v-if="existingMethods.length > 0">
                            <div class="row row-small" role="listbox" tabindex="0">
                              <div
                                class="lcu-existing-option"
                                :class="{
                                  'lcu-existing-optionSelected': selectedPaymentMethod === card.id,
                                }"
                                v-for="card in existingMethods"
                                role="option"
                                tabindex="-1"
                                @click.prevent="
                                  selectedPaymentMethod = card.id; existingPaymentError = false"
                                :aria-selected="selectedPaymentMethod === card.id"
                                :key="card.id">
                                  <span
                                    :class="'lcu-cardLogo-' + card.brand"
                                    class="lcu-card-option" />
                                  <span>xxxx {{ card.last4 }}</span>
                                  <span>{{ card.name }}</span>
                                  <span>{{ card.expMonth }}/{{ card.expYear }}</span>
                                  <span v-if="defaultMethod === card.id">(predeterminado)</span>
                                  <span v-else> </span>
                              </div>
                            </div>
                            <div class="row row-small" v-if="existingPaymentError">
                              <span class="lcu-register-errorMsg">
                                {{ existingPaymentError }}
                              </span>
                            </div>
                          </div>
                          <div v-else>
                            <p>No tienes métodos de pago guardados.</p>
                          </div>
                        </div>
                        <div
                          class="lcu-retrieve-errorMsg"
                          v-if="loadPaymentMethodsError && !loadingPaymentMethods">
                          {{ loadPaymentMethodsError }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="lcu-summary-box">
                  <div class="row">
                    <div class="lcu-summary-item">
                      <img
                        :src="program.image || DEFAULT_PROGRAM_IMAGE"
                        class="lcu-summary-itemImage" alt="Program image" />
                      <div>
                        <p>{{ program.degree }} en {{ program.name }}</p>
                        <strong>{{ getProgramTotals.subtotal }}</strong>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <hr class="line-break"/>
                  </div>
                  <div class="row">
                    <div class="lcu-discount-input">
                      <form-field :id="'discount'" :label="''">
                        <input
                          type="text"
                          id="discount"
                          v-model="discount"
                          @input="validateDiscount"
                          :readonly="discountApplied"
                          placeholder="Código de descuento"
                          :class="{
                            'lcu-register-inputError': discountError,
                            'lcu-disabled-input': discountApplied
                          }"
                          class="lcu-form-inputText lcu-input-discount" />
                      </form-field>
                      <button-cta
                        :text="!discountApplied ? 'Aplicar' : 'Limpiar'"
                        :type="'primary-light'"
                        :loading="discountLoader"
                        :disabled="discountLoader"
                        @on-click="!discountApplied ? onApplyDiscount() : clearDiscount()" />
                    </div>
                    <div class="row row-small" v-if="discountError">
                      <span class="lcu-register-errorMsg">
                        {{ discountError }}
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <hr class="line-break"/>
                  </div>
                  <div class="row">
                    <div class="lcu-summary-totals">
                      <span>Subtotal: </span>
                      <span>{{ getProgramTotals.subtotal }} </span>
                      <span
                        class="lcu-summary-savings"
                        v-if="getProgramTotals.savings">Ahorro:</span>
                      <span
                        class="lcu-summary-savings"
                        v-if="getProgramTotals.savings">-{{ getProgramTotals.savings }}</span>
                      <span>Impuestos: </span>
                      <span>{{ getProgramTotals.taxes }} </span>
                      <span :class="{
                        'lcu-summary-total': !installmentDueToday
                      }">Total: </span>
                      <span :class="{
                        'lcu-summary-total': !installmentDueToday
                      }">{{ getProgramTotals.total }} </span>
                    </div>
                    <div
                      v-if="installmentDueToday"
                      class="lcu-summary-totals lcu-summary-installment">
                      <span class="lcu-summary-total">Pago parcial vence hoy: </span>
                      <span class="lcu-summary-total">{{ installmentDueToday.amount }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section class="section" v-if="registeringError">
              <div class="lcu-register-error">{{ registeringError }}</div>
            </section>
            <section class="section">
              <div class="col-grid-2">
                <button-cta
                  :text="'ATRÁS'"
                  :disabled="registeringLoader"
                  :classes="['lcu-back-btn']"
                  border
                  @on-click="registrationStep = 'agreement'" />
                <button-cta
                  :text="'Confirmar y Pagar'"
                  :loading="registeringLoader"
                  :disabled="registeringLoader"
                  @on-click="onRegister" />
              </div>
            </section>
          </div>
          <div v-if="registrationStep === 'completed'">
            <section class="section">
              <header class="lcu-section-subHeader lcu-center-text">
                ¡Felicidades! Ya estas registrado oficialmente.
              </header>
            </section>
            <section class="section">
              <div class="lcu-video-wrapper">
                <video-player
                  @on-ready="() => {}"
                  :options="{
                    controls: true,
                    autoplay: true,
                    sources: [
                      {
                        src: `${WEB_ASSETS_URL}/public-assets/lcu-welcome-video.mp4`,
                        type: 'video/mp4'
                      }
                    ]
                  }" />
              </div>
            </section>
            <section class="section">
              <div class="row row-center">
                <p>
                 Ahora puedes acceder a este programa en cualquier momento.
                </p>
              </div>
              <div class="row row-center">
                <button-cta
                  :text="'Ir al Programa'"
                  border
                  :class="['lcu-registered-button']"
                  @on-click="$router.push({ path: '/programas/registrada/' + program.slug })" />
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { loadStripe } from '@stripe/stripe-js';
import PageLegend from 'ç/page-legend/PageLegend.vue';
import ButtonCta from 'ç/buttons/Cta.vue';
import BulletLegend from 'ç/bullet-legend/BulletLegend.vue';
import Announement from 'ç/announcement/Announcement.vue';
import SpinLoader from 'ç/loaders/spin/Spin.vue';
import FormValidator from '@/mixins/Validator.vue';
import FormField from 'ç/forms/inputs/Field.vue';
import VideoPlayer from 'ç/video-player/VideoPlayer.vue';
import globalUtils from '@/globals/utils';
import {
  DEFAULT_PROGRAM_IMAGE,
  TRY_AGAIN,
  NOTIFICATION_SUCCESS,
  WEB_ASSETS_URL,
} from '@/globals/constants';
import Programs from '@/mixins/Programs.vue';

export default {
  name: 'register-program',
  mixins: [FormValidator, Programs],
  computed: {
    ...mapGetters(['user']),
    getCurrentStep() {
      if (this.registrationStep === 'completed') {
        return 3;
      }
      if (this.registrationStep === 'confirm') {
        return 2;
      }
      // if (this.registrationStep === 'agreement') {
      //   return 2;
      // }
      return 1;
    },
    installmentDueToday() {
      const { installments } = this;
      return installments.length > 0 ? installments[0] : false;
    },
    getProgramTotals() {
      const currencies = this.program?.pricing?.currencies;
      const USD = currencies?.USD;
      return {
        subtotal: USD.subtotal,
        taxes: USD.taxes,
        total: USD.total,
        savings: USD.savings,
      };
    },
  },
  components: {
    PageLegend,
    ButtonCta,
    BulletLegend,
    SpinLoader,
    VideoPlayer,
    'annoucement-banner': Announement,
    'form-field': FormField,
  },
  data() {
    return {
      TRY_AGAIN,
      WEB_ASSETS_URL,
      registrationStep: 'agreement',
      learnPreference: 'read',
      programAgreement: false,
      loginModal: false,
      registeringLoader: false,
      registeringError: false,
      paymentType: 'full',
      paymentMethod: 'new',
      existingPaymentError: false,
      existingMethods: [],
      savePaymentMethod: true,
      DEFAULT_PROGRAM_IMAGE,
      loadingPaymentMethods: false,
      loadPaymentMethodsError: false,
      selectedPaymentMethod: false,
      defaultMethod: false,
      discount: '',
      discountError: false,
      discountLoader: false,
      discountApplied: false,
      installmentError: false,
      installmentLoading: false,
      installments: [],
      validations: {
        name: {
          value: '',
          required: true,
          errors: [],
        },
      },
      stripe: null,
      stripeLoading: false,
      cardElement: null,
      stripePublishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      stripeCardError: '',
    };
  },
  created() {
    this.getProgram({ getPricing: true });
  },
  watch: {
    registrationStep(step) {
      if (step === 'confirm' && this.paymentMethod === 'new' && !this.cardElement) {
        this.$nextTick(() => {
          this.stripeSetup();
        });
      }
    },
    paymentMethod(method) {
      const isConfirmStep = this.registrationStep === 'confirm';
      if (method === 'new' && isConfirmStep && !this.cardElement) {
        this.$nextTick(() => {
          this.stripeSetup();
        });
      }
      if (method === 'existing' && isConfirmStep && this.cardElement) {
        this.stripeCardError = '';
        this.cardElement.destroy();
        this.cardElement = null;
      }
    },
  },
  beforeUnmount() {
    if (this.cardElement) {
      this.cardElement.destroy();
      this.cardElement = null;
    }
  },
  methods: {
    async stripeSetup() {
      if (this.cardElement) {
        return;
      }
      try {
        this.stripeLoading = true;
        this.stripe = await loadStripe(this.stripePublishableKey);
        const elements = this.stripe.elements({ locale: 'es' });
        this.cardElement = elements.create('card', globalUtils.stripInputConfig);
        this.cardElement.mount('#card-element');
        this.cardElement.on('change', (event) => {
          this.stripeCardError = event.error ? event.error.message : '';
        });
      } catch (e) {
        const message = e.message || e;
        this.$log.error('Stripe setup error: ', message);
      } finally {
        this.stripeLoading = false;
      }
    },
    async loadPaymentMethods() {
      this.loadingPaymentMethods = true;
      try {
        const { paymentMethods, defaultMethod } = await this.$students({ method: 'getPaymentMethods' });
        this.existingMethods = paymentMethods;
        this.defaultMethod = defaultMethod;
        if (paymentMethods.length > 0 && defaultMethod) {
          this.selectedPaymentMethod = this.defaultMethod;
        } else if (paymentMethods.length > 0 && !defaultMethod) {
          this.selectedPaymentMethod = paymentMethods[0].id;
        }
      } catch (e) {
        this.loadPaymentMethodsError = 'Hubo un problema al recuperar tus métodos de pago.';
        this.$log.error(e.message || e);
      } finally {
        this.loadingPaymentMethods = false;
      }
    },
    onSelectFull() {
      this.installments = [];
    },
    async onSelectInstallments() {
      this.installmentLoading = true;
      try {
        const { payment } = await this.$students({
          method: 'getProgramInstallments',
          payload: {
            slug: this.program.slug,
            discountCode: this.discountApplied,
          },
        });
        this.installments = payment.displayInstallments;
        this.$log.info('installments: ', payment);
      } catch (e) {
        const message = e.message || e;
        this.installmentError = message;
        this.$log.error(message);
      } finally {
        this.installmentLoading = false;
      }
    },
    async onApplyDiscount() {
      if (this.discountLoader) {
        return;
      }
      this.discountError = false;
      if (this.discount === '') {
        this.discountError = this.formValidationMessages.required;
        return;
      }
      this.discountLoader = true;
      this.discountApplied = false;
      try {
        const { USD } = await this.$students({
          method: 'programCouponCheck',
          payload: {
            slug: this.program.slug,
            code: this.discount,
          },
        });
        const { currencies } = this.program.pricing;
        currencies.USD.savings = USD.savings;
        currencies.USD.taxes = USD.newTaxes;
        currencies.USD.total = USD.newTotal;
        this.discountApplied = this.discount;
        if (this.paymentType === 'installments') {
          await this.onSelectInstallments();
        }
        this.$notify({
          title: NOTIFICATION_SUCCESS,
          text: 'Código de descuento aplicado',
          type: 'success',
        });
      } catch (e) {
        const message = e.message || e;
        this.discountError = message;
        const initialUSD = _.cloneDeep(this.initialProgram).pricing.currencies.USD;
        this.program.pricing.currencies.USD = initialUSD;
        this.$log.error(message);
      } finally {
        this.discountLoader = false;
      }
    },
    clearDiscount() {
      this.discountApplied = false;
      this.discount = '';
      this.program.pricing.currencies.USD = _.cloneDeep(this.initialProgram).pricing.currencies.USD;
      if (this.paymentType === 'installments') {
        this.onSelectInstallments();
      }
    },
    validateDiscount() {
      if (this.discount === '') {
        this.discountError = this.formValidationMessages.required;
      } else {
        this.discountError = false;
      }
    },
    async onRegister() {
      if (this.registeringLoader) {
        return;
      }
      this.existingPaymentError = false;
      this.registeringError = false;
      try {
        const registerPayload = {
          slug: this.program.slug,
          paymentMethod: this.paymentMethod, // new or existing
          paymentType: this.paymentType, // full or installments
          discountCode: this.discount,
          degree: this.program.degree,
          name: this.program.name,
          image: this.program.image,
          learnPreference: this.learnPreference,
        };
        if (this.paymentMethod === 'new') {
          const validation = this.validate(['name']);
          if (!validation.passed) {
            return;
          }
          if (!this.stripe || !this.cardElement) {
            throw new Error('Stripe card input is not ready.');
          }
          const { name } = this.validations;
          const { paymentMethod, error } = await this.stripe.createPaymentMethod({
            type: 'card',
            card: this.cardElement,
            billing_details: {
              name: name.value,
              email: this.user.email,
            },
          });
          if (error) {
            throw new Error(error.message);
          }
          registerPayload.savePaymentMethod = this.savePaymentMethod;
          registerPayload.paymentMethodId = paymentMethod.id;
          registerPayload.billingDetails = {
            name: name.value,
            email: this.user.email,
          };
        }
        if (!this.validateExistingPayment().passed) {
          return;
        }
        if (this.paymentMethod === 'existing') {
          registerPayload.selectedPaymentMethod = this.selectedPaymentMethod;
        }
        this.registeringLoader = true;
        const { purchase, programs } = await this.$students({
          method: 'registerProgram',
          payload: registerPayload,
        });
        this.$store.dispatch('setGlobalValue', {
          item: this.user,
          key: 'programs',
          value: programs,
        });
        this.$log.info('registerProgram: ', purchase);
        this.registrationStep = 'completed';
      } catch (e) {
        this.registeringError = `Se produjo un error al realizar el registro en este programa. Por favor, inténtelo de nuevo más tarde. [${e?.message || e}]`;
        this.$log.error(e.message || e);
      } finally {
        this.registeringLoader = false;
      }
    },
    validateExistingPayment() {
      const passed = this.paymentMethod === 'new' || (this.paymentMethod === 'existing' && this.selectedPaymentMethod);
      this.existingPaymentError = passed ? false : this.formValidationMessages.required;
      return {
        passed,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-courseInfo-grid {
  display: grid;
  grid-gap: 50px;
  grid-template-columns: 1fr max-content;

  @media only screen and (max-width: $mobile-max) {
    grid-template-columns: 1fr;
    grid-gap: 25px;
  }
}

.lcu-learn-options {
  padding: 0 100px;
  margin-bottom: 25px;

  &:last-child {
    margin-bottom: 0;
  }
}

.lcu-learn-option {
  border: 2px solid $page-border;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
  font-size: 21px;
  font-weight: bold;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: border-color .2s;

  &:hover {
    border-color: $legacy-primary;
    cursor: pointer;
  }
}

.lcu-selected-option {
  border-color: $legacy-primary;
}

.lcu-learn-icon {
  margin-bottom: 20px;
  width: 120px;
}

.lcu-card-container {
  padding: 20px;
  border-radius: 3px;
  background-color: $off-white;
}

.lcu-summary-box {
  padding: 25px 20px;
  border-radius: 3px;
  background-color: $off-white;
}

.lcu-summary-item {
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-gap: 25px;
}

.lcu-summary-itemImage {
  width: 140px;
  border: 1px solid $gray;
}

.lcu-summary-totals {
  display: grid;
  grid-template-columns: 1fr min-content;
  grid-column-gap: 30px;
  grid-row-gap: 10px;

  span {
    justify-self: end;
  }
}

.lcu-summary-total {
  font-family: raleway-extra-bold;
  font-size: 18px;
}

.lcu-back-btn {
  &:before {
    font-family: 'lcu';
    content: '\e80a';
    display: inline-block;
    margin-right: 5px;
    transform: rotate(180deg);
    font-weight: bold;
  }
}

.lcu-next-btn {
    &:after {
    font-family: 'lcu';
    content: '\e80a';
    display: inline-block;
    margin-left: 5px;
    font-weight: bold;
  }
}

.lcu-small-disclaimer {
  font-size: 13px;
  color: $gray-medium;
  display: block;
  margin-bottom: 5px;
  &:last-child {
    margin-bottom: 0;
  }
}

.lcu-programLoad-error {
  text-align: center;
  font-size: 18px;
}

.lcu-program-registered {
  text-align: center;
  font-size: 18px;
}

.lcu-registered-image {
  border: 1px solid $page-border;
  border-radius: 5px;
  overflow: hidden;
  width: 250px;

  @media only screen and (max-width: $mobile-max) {
    width: 100%;
  }
}

.lcu-program-brokenImg {
  width: 165px;
}

.lcu-register-inputText {
  background-color: transparent;
  border: 0;
  border-bottom: 2px solid $legacy-primary;
  color: $legacy-primary;
  font-size: 16px;
  padding: 5px;
  width: 100%;

  &:focus-visible {
    @include no-focus;
    border-bottom: 2px solid $legacy-primary;
  }

  &:focus {
    @include no-focus;
    border-bottom: 2px solid $legacy-primary;
  }

  &:focus-within {
    @include no-focus;
    border-bottom: 2px solid $legacy-primary;
  }
}

.lcu-retrieve-errorMsg {
  color: $danger;
  display: inline-block;
}

.lcu-register-errorMsg {
  color: $danger;
  display: inline-block;
  font-size: 16px;
}

.lcu-register-inputError {
  background-color: #ffe6e6;
  border-color: $danger;

  &:focus-visible {
    border-color: $danger;
  }

  &:focus {
    border-color: $danger;
  }

  &:focus-within {
    border-color: $danger;
  }
}

.lcu-mobile-bump {

  @media only screen and (max-width: $mobile-max) {
    margin-bottom: 25px;
  }
}

.lcu-card-containerError {
  border: 1px solid $danger;
  background-color: #ffe6e6;
}

.lcu-form-checkbox {
  background-color: rgba($black, .05);

  &:checked {
    background-color: $legacy-primary;
  }
}

.lcu-register-error {
  border: 1px solid $danger;
  background-color: #ffeded;
  padding: 15px;
  color: $danger;
  border-radius: 5px;
}

.lcu-registered-button {
  width: 50%;

  @media only screen and (max-width: $mobile-max) {
    width: 100%;
  }

  &:after {
    font-family: 'lcu';
    content: '\e80a';
    display: inline-block;
    margin-left: 5px;
  }
}

.lcu-paper-terms {
  padding: 35px;
  width: 80%;
  border: 1px solid $page-border;
  margin: 0 auto 35px;
  border-radius: 5px;

  @media only screen and (max-width: $mobile-max) {
    width: 100%;
  }
}

.lcu-term-link {
  text-decoration: underline;
  color: $legacy-secondary;

  &:hover {
    text-decoration: none;
  }
}

.lcu-terms-wrapper {
  display: grid;
  width: max-content;
  align-self: center;
}

.lcu-video-wrapper {
  margin: 0 auto;
  width: 75%;

  @media only screen and (max-width: $mobile-max) {
    width: 100%;
  }
}

.lcu-discount-input {
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-gap: 10px;
  justify-content: end;
  align-items: center;
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: 0;
  }
}

.lcu-existing-option {
  background-color: $white;
  border: 2px solid transparent;
  border-radius: 3px;
  padding: 10px;
  display: grid;
  grid-template-columns: repeat(6, max-content);
  grid-gap: 15px;
  align-items: center;
  margin-bottom: 2px;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    cursor: pointer;
  }
}

.lcu-existing-optionSelected {
  background-color: #fffaef;
  border-color: $legacy-secondary;
}

.lcu-summary-savings {
  color: $success;
  font-weight: bold;
}

.lcu-input-discount {
  color: $legacy-primary;
}

.lcu-disabled-input {
  background-color: $gray-lightest;
  color: #818181;

  &:hover {
    cursor: not-allowed;
  }

  &:focus {
    border-color: transparent;
  }

  &:focus-within {
    border-color: transparent;
  }
}

.lcu-card-hint {
  font-size: 13px;
  color: $gray-medium;
  margin-top: 15px;
}

.lcu-card-option {

  &:before {
    color: $legacy-secondary;
    font-family: 'lcu';
    content: '\e824';
    font-size: 24px;
    margin: 0;
  }
}

.lcu-cardLogo-mastercard {

    &:before {
    content: '\e827';
  }
}

.lcu-cardLogo-visa {

    &:before {
    content: '\e826';
  }
}

.lcu-cardLogo-discover {

    &:before {
    content: '\e825';
  }
}

.lcu-cardLogo-amex {

    &:before {
    content: '\e828';
  }
}

.lcu-cardLogo-american-express {

    &:before {
    content: '\e828';
  }
}
.lcu-installment-header {
  display: grid;
  grid-template-columns: 20% 1fr;
  grid-gap: 25px;
  padding-bottom: 10px;
  border-bottom: 1px solid $page-border;
}

.lcu-installment-row {
  display: grid;
  grid-template-columns: 20% 1fr;
  grid-gap: 25px;
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}

.lcu-installment-bold {
  font-weight: bold;
}

.lcu-installment-body {
  padding: 10px 0 25px;
}

.lcu-summary-installment {
  border-top: 1px solid $page-border;
  margin-top: 20px;
  padding-top: 12px;
}
</style>
